var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.is_link ? 'a' : 'button',_vm._b({tag:"component",staticClass:"default-button",class:_vm.component_classes,on:{"click":function($event){return _vm.$emit('click', $event)}}},'component',_vm.link_data,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }